import { useEffect, useState } from "react";
import { ImageOff, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export const AuthImage = ({ path, alt, className, testid }) => {
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    if (!path) return undefined;
    let url;
    let alive = true;
    api.get(`/files/${path}`, { responseType: "blob" })
      .then((r) => {
        url = URL.createObjectURL(r.data);
        if (alive) setSrc(url);
      })
      .catch(() => alive && setErr(true));
    return () => {
      alive = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [path]);

  if (!path || err)
    return (
      <div data-testid={testid} className={`grid place-items-center bg-slate-100 text-slate-400 text-xs ${className}`}>
        <ImageOff className="h-5 w-5" />
      </div>
    );
  if (!src)
    return (
      <div className={`grid place-items-center bg-slate-100 ${className}`}>
        <Loader2 className="h-4 w-4 animate-spin text-slate-400" />
      </div>
    );
  return <img data-testid={testid} src={src} alt={alt} className={className} />;
};
